import * as React from "react";
var currentNotFoundState = null;
var notFoundListeners = /* @__PURE__ */ new Set();
function getNotFoundState() {
  return currentNotFoundState;
}
function setNotFoundState(state) {
  currentNotFoundState = state;
  notFoundListeners.forEach(function(listener) {
    return listener();
  });
}
function clearNotFoundState() {
  if (currentNotFoundState !== null) {
    currentNotFoundState = null;
    notFoundListeners.forEach(function(listener) {
      return listener();
    });
  }
}
function useNotFoundState() {
  var [, forceUpdate] = React.useReducer(function(x) {
    return x + 1;
  }, 0);
  React.useEffect(function() {
    notFoundListeners.add(forceUpdate);
    return function() {
      notFoundListeners.delete(forceUpdate);
    };
  }, []);
  return currentNotFoundState;
}
function findNearestNotFoundRoute(pathname, rootNode) {
  if (!rootNode) return null;
  var pathParts = pathname.split("/").filter(Boolean);
  function findNotFoundInNode(node) {
    if (node.route === "+not-found") {
      return node;
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = (node.children || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        if (child.route === "+not-found") {
          return child;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return null;
  }
  function traverse(node, depth, notFoundStack) {
    var notFoundAtLevel = findNotFoundInNode(node);
    if (notFoundAtLevel) {
      notFoundStack.push(notFoundAtLevel);
    }
    if (depth >= pathParts.length) {
      return notFoundStack.length > 0 ? notFoundStack[notFoundStack.length - 1] : null;
    }
    var segment = pathParts[depth];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = (node.children || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        if (child.route === "+not-found") continue;
        var childRoute = child.route || "";
        var isDynamic = childRoute.startsWith("[");
        var isMatch = childRoute === segment || isDynamic;
        if (isMatch) {
          var result = traverse(child, depth + 1, [
            ...notFoundStack
          ]);
          if (result) return result;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
    return notFoundStack.length > 0 ? notFoundStack[notFoundStack.length - 1] : null;
  }
  return traverse(rootNode, 0, []);
}
function findRouteNodeByPath(notFoundPath, rootNode) {
  if (!rootNode) return null;
  var normalizedPath = notFoundPath.replace(/^(\.?\/)+|\/+$/g, "");
  function searchNode(node) {
    var nodeContextKey = node.contextKey || "";
    var contextKeyNormalized = nodeContextKey.replace(/^(\.?\/)+/, "").replace(/\.[^.]+$/, "");
    if (contextKeyNormalized === normalizedPath) {
      return node;
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = void 0;
    try {
      for (var _iterator2 = (node.children || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var child2 = _step2.value;
        var found2 = searchNode(child2);
        if (found2) return found2;
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
    return null;
  }
  var found = searchNode(rootNode);
  if (found) return found;
  var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
  try {
    for (var _iterator = (rootNode.children || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var child = _step.value;
      var found1 = searchNode(child);
      if (found1) return found1;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
  return null;
}
export {
  clearNotFoundState,
  findNearestNotFoundRoute,
  findRouteNodeByPath,
  getNotFoundState,
  setNotFoundState,
  useNotFoundState
};
//# sourceMappingURL=notFoundState.js.map
